import { PropTypes } from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import { resolveRouteServiceApp } from 'utils/productHelpers'

import { RouteContentGetter } from 'layers/content/v2/Hocs/RouteContentGetter'
import withSiteContext from 'layers/content/v2/Hocs/withSiteContext'
import {
  selectCurrentProgramClasses,
  parseGradeAndProgram,
  getCourseLinks,
  coursesWithNewContentfulIds,
} from 'utils/lmsHelpers'

import NavigationHelper from 'layers/navigation/navigationHelper'
import { operations as lmsOperations } from 'store/lmsManager'
import { operations as loadingOperations } from 'store/loadingManager'

import LessonsComponent from './component'
import {
  courseSelectHandlerFactory,
  classSelectHandlerFactory,
  gotoDashboardHandlerFactory,
} from './handlers'
import { processCourseTreeCollectionv2ToWorkWithV1CourseShapes } from './data'

import { useDigitalLicensesWithLoading } from 'lib/api/hooks/digitalLicenses'

import { CourseManagerGetter } from 'layers/content/v2/Hocs/CourseManagerGetter'

export const LessonsContainer = props => {
  const {
    match,
    navigationEvent,
    instructorData,
    courseManager,
    userContext,
    productTabTitle,
    currentSite,
    // CreateCourse props
    lms,
    pathName,
    userAccess,
    userProfile,
    createCourseInstance,
    createCourseInstanceV2,
    createCourseInstanceV2ProgramFlex,
    deletingCourseCreatedStatus,
    deleteCourseInstance,
    updateCourseInstance,
  } = props || {}

  // TODO: FIX ONCE WE DO DYNAMIC COURSE FETCHING ON PAGE DATA FROM CONTENT SERVICE This whole containers methods of getting and selecting course info is needed until we make page data fetching for course structures dynamic. Also until we remove all the v2 to v1 lesson shaping we are doing

  // TODO LEARN-23339 Update this to be in the secondstep-learn/src/experienceComponents/CreateCourse/flag.on/container.js once we remove siteSelection flags. Need to update in dashboard as well.
  //  Use the combined hook for digital licenses and loading state. The createClass modal needs this data to get license data to create a class
  useDigitalLicensesWithLoading()

  const classes = selectCurrentProgramClasses({
    instructorData,
    courseManager,
    match,
    userContext,
  })

  const { program, programKey } = parseGradeAndProgram(match?.url)
  const courseLinks = getCourseLinks(
    coursesWithNewContentfulIds({ programType: program }),
  )
  const courseTreesWithDisplayTitles = processCourseTreeCollectionv2ToWorkWithV1CourseShapes(
    courseManager?.courseTrees,
  )

  // Extract lesson completion goal value from currentSite based on program type
  let sitePreferences = null
  if (program === 'K5SelDigital') {
    sitePreferences = currentSite?.k5SitePreferences
  } else if (program === 'MspDigital') {
    sitePreferences = currentSite?.middleSchoolSitePreferences
  }
  const lessonCompletionGoalValue =
    sitePreferences?.lessonCompletionGoalValue || null

  return (
    <LessonsComponent
      classes={classes}
      contentfulCourses={courseTreesWithDisplayTitles}
      courseLinks={courseLinks}
      createCourseInstance={createCourseInstance}
      createCourseInstanceV2={createCourseInstanceV2}
      createCourseInstanceV2ProgramFlex={createCourseInstanceV2ProgramFlex}
      deleteCourseInstance={deleteCourseInstance}
      deletingCourseCreatedStatus={deletingCourseCreatedStatus}
      goToDashboard={gotoDashboardHandlerFactory(navigationEvent)}
      lessonCompletionGoalValue={lessonCompletionGoalValue}
      lms={lms}
      match={match}
      onClassClick={classSelectHandlerFactory(programKey, navigationEvent)}
      onComponentClick={navigationEvent}
      onCourseClick={courseSelectHandlerFactory(programKey, navigationEvent)}
      pathName={pathName}
      productName={programKey}
      productTabTitle={productTabTitle}
      updateCourseInstance={updateCourseInstance}
      userAccess={userAccess}
      userContext={userContext}
      userProfile={userProfile}
    />
  )
}

const mapStateToProps = state => {
  const { lmsManager, userContextManager, productManager } = state || {}
  const instructorData = lmsManager?.instructorData

  return {
    // Existing props
    userContext: userContextManager,
    productTabTitle: productManager?.productMap?.name || '',
    instructorData: instructorData,
    // CreateCourse required props
    lms: lmsManager,
    pathName: state.router?.location?.pathname,
    userAccess: state.userAccessManager?.access,
    userProfile: state.userProfileManager,
  }
}

const mapDispatchToProps = {
  // Existing dispatchers
  fetchInstructorData: lmsOperations.fetchInstructorData,
  fetchInstructorDataV2: lmsOperations.fetchInstructorDataV2,
  setAppIsLoadingState: loadingOperations.setIsLoadingState,
  setAppNotLoadingState: loadingOperations.setNotLoadingState,
  // CreateCourse required dispatchers
  createCourseInstance: lmsOperations.createCourseInstance,
  createCourseInstanceV2: lmsOperations.createCourseInstanceV2,
  createCourseInstanceV2ProgramFlex:
    lmsOperations.createCourseInstanceV2ProgramFlex,
  deletingCourseCreatedStatus: lmsOperations.deletingCourseCreatedStatus,
  deleteCourseInstance: lmsOperations.deleteCourseInstance,
  updateCourseInstance: lmsOperations.updateCourseInstance,
}

const mapDispatchToPropsCombiner = {
  ...mapDispatchToProps,
  ...NavigationHelper.mapDispatchToProps,
}

export default withSiteContext(
  CourseManagerGetter(
    RouteContentGetter(
      withRouter(
        connect(mapStateToProps, mapDispatchToPropsCombiner)(LessonsContainer),
      ),
      {
        app: ({ route }) => resolveRouteServiceApp(route),
      },
    ),
  ),
)

LessonsContainer.propTypes = {
  courseManager: PropTypes.object,
  currentSite: PropTypes.object,
  instructorData: PropTypes.object,
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
    params: PropTypes.shape({
      productName: PropTypes.string,
      verb: PropTypes.string,
    }),
  }),
  navigationEvent: PropTypes.func,
  productTabTitle: PropTypes.string,
  userContext: PropTypes.object,
}
